'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sayHi = exports.reduceGraphDataByGender = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reduceGraphDataByGender = exports.reduceGraphDataByGender = function reduceGraphDataByGender(data) {
  return _lodash2.default.reduce(data, function (acc, item, key) {
    var gender = key.charAt(0);
    acc[gender].push((0, _extends3.default)({}, item, {
      group: key.substr(1)
    }));
    return acc;
  }, { M: [], F: [], U: [] });
};

var sayHi = exports.sayHi = function sayHi() {
  return _lodash2.default.constant('Hi!');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/demographics.js
 ** module id = 979
 ** module chunks = 0
 **/